class ExpertWidget extends HTMLElement {
  constructor() {
    super();
    const triggerLink = this.querySelector("a");

    if (triggerLink != null) {
      triggerLink.addEventListener("click", this.onLinkClick.bind(this));
    }
  }

  onLinkClick(event) {
    event.preventDefault();

    const whatsAppChatContainer = document.getElementsByClassName(
      "csaas-whatsapp-outer-forms"
    );

    if (
      whatsAppChatContainer.length > 0 &&
      !whatsAppChatContainer[0].classList.contains("active")
    ) {
      setTimeout(() => {
        whatsAppChatContainer[0].classList.add("is-active", "active");
      }, 500);
    }
  }
}

customElements.define("expert-widget", ExpertWidget);
